import { getDocs, collection } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db, storage } from "../firebaseConfig";

/**
 * Obtém lista de subsidiárias do banco de dados
 */
const fetchSubsidiaries = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "subsidiary"));
    return querySnapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        value: doc.id,
        label: data.name || "No Name",
      };
    });
  } catch (error) {
    console.warn("[fetchSubsidiaries] Erro ao buscar subsidiarias: ", error);
    return [];
  }
};



/**
 * Faz upload de um ícone de módulo para o Firebase Storage
 * @param {File} file - Arquivo de imagem a ser enviado
 * @returns {Promise<string>} URL pública do arquivo enviado
 * @throws {Error} Se o arquivo for inválido ou o upload falhar
 */
const uploadModuleIcon = async (file) => {
    if (!file) {
        return;
    }

    // Validacao de imagem
    if (!file.type.startsWith("image/")) {
        throw new Error("File must be an image")
    }

    // Validacao de tamanho
    const maxSize = 5 * 1024 * 1024
    if (file.size > maxSize) {
        const maxMB = (maxSize / 1024 * 1024).toFixed(1)
        throw new Error(`File too large. Max size: ${maxMB}MB`)
    }

    // Nome unico para evitar conflitos
    const timestamp = Date.now()
    const sanitizedName = file.name.replace(/[^a-zA-Z0-9.-]/g, "_");
    const uniqueName = `${timestamp}_${sanitizedName}`

    // Upload
    const storageRef = ref(storage, `modulesIcons/${uniqueName}`);

    await uploadBytes(storageRef, file)
    const fileURL = await getDownloadURL(storageRef)

    return fileURL

}


export default {fetchSubsidiaries, uploadModuleIcon}
